import React, {useMemo} from 'react'
import {Select} from "antd";
import {useSupplierFormItem} from "../providers/SupplierFormItemProvider";
import {FormInputComponent} from "../../../components/form/Form";

const {Option} = Select;


const SupplierProfileDocumentForm = (props) => {

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing,
        yearOptions
    } = useSupplierFormItem()

    const docTypes = useMemo(() => {
        return TB.reduce(laravel.talent_profile_document_types || {}, (result, doc, docId) => {
            result.push({label: doc, value: parseInt(docId)})
            return result
        }, []);
    }, []);

    return (
        <div className="flex flex-col">
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-5/12">
                    <FormInputComponent
                        fieldName={`type`}
                        value={profileItem.type || null}
                        type="antd-input"
                        required={true}
                        validateBeforeSubmit={false}
                        label={TB.trans('talent.profile_document_form.document_type_label')}
                        placeholder={TB.trans('talent.profile_document_form.document_type_placeholder')}
                    >

                        <Select value={profileItem.type}>
                            {TB.map(docTypes, (opt) => (
                                <Option key={`opt-${profileIndex}-${opt.label}`} value={opt.value}>
                                    <span>{opt.label}</span>
                                </Option>
                            ))}

                        </Select>
                    </FormInputComponent>
                </div>
            </div>

            <div className="field-section flex-row">
                <div className="field px-3.5 basis-10/12">
                    <FormInputComponent
                        fieldName={`path`}
                        value={profileItem.path}
                        type="file"
                        validateBeforeSubmit={false}
                        required={true}
                        size={profileItem?.size}
                        viewable={typeof profileItem.path === 'string'}
                        label={TB.trans('talent.profile_document_form.upload_document_label')}
                        fileNameDisplay={() => {
                            return profileItem.name || profileItem.display_name
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default SupplierProfileDocumentForm;

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};